var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.986664,
    y: 0.72998,
    width: 59.3363,
    height: 59.3363,
    fill: "url(#pattern0_213_101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_213_101",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_213_101",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_213_101",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABDFJREFUeF7tnD2IFWcYhc+LRFkRIoqiaGEgomCxiIWNlikCQRsbC22sgiaCWIiCIFgJKeIPadIKAZuATUgbBUsRLGPSqFVSx8YTR0fQde7emfuemfmGPdPeOefO+zzztzOXDXgpikAUtTXeGFhIYTuBhVhIYQQK2xwfIRZSGIHCNsdHiIUURqCwzfERstaEkFwH4BCAowD2A9gHYDeAzQA2AfisYhIRk9g5+p6nFwgkK8hfAzgF4CsAn8/bEUsWMuQ8UiEktwL4HsC3ALbNk/Dh5yUKGWMeiRCSGwFcBnC+Pg11cfF23ZKEjDlPWgjJbwDcArCns4UPAqUIGXuehYWQ3ADgBoDvqh08I6OEI6SUeRYCSXLnmzun+/XdU9bF6KeskubpLITkFwB+B/ClxERdMtYpq7R5OgkhWUn4A8AOpYyxTlklztNaCMntAB4A2KuWMYaQUudpJaS+4D1UXjNWSh3ylFXyPG2F3AZwto8j433nwEKKnWeukPq+vLqj6nUZSkjp86wqhOQSgKcAqjurXpchhExhnnlCrgO4IjbxEsBPAH578/Dxz4j4V9w/s45k8fPMFFI/WPt70WdTDVQI4EcAlyLi1VAS3n/PVOZZTcg1AFdF4F4DOB0Rd0V9nWtITmKeRiH18//nXR+hr0LpYkT80JmiKDCleWYJOQ7gVxGP+xFxTNS1UA3JycwzS8g9ACcWmv7j0H8ADkTEM0HXwhUkJzPPJ0Lqd8b/tHnt2oLQnYg412K93laZ2jxNQg4DeCQidDAiHou6FqohOal5moRcAKC4AD+JiOWFKApDJCc1T5OQnwGcETC5GRHVO/ZRF5KTmqdJSPW+44iA4smI+EXQk6ogOal5moT8lf3BQk1wOSKepGgKwiQnNU+TkOoOa4uAxa6IeCHoSVWQnNQ8TUKq50zrUxTehZciovo7ZNSF5KTmaRJSPQRML0M8Tm+zkSQnNY+FtLE64C8rLcRCWhIQreZTlgjkrJqu1yaVkL7GWjlPb6esoQaY9z0WMo9Q8nMfIUmA6riFqIkm+ywkCVAdtxA10WSfhSQBquMWoiaa7LOQJEB13ELURJN9FpIEqI5biJposs9CkgDVcQtRE032WUgSoDpuIWqiyT4LSQJUxy1ETTTZZyFJgOq4haiJJvssJAlQHbcQNdFkn4UkAarjFqImmuyzkCRAddxC1ESTfRaSBKiOW4iaaLLPQpIA1XELURNN9llIEqA6biFqosk+C0kCVMctRE002WchSYDquIWoiSb7LCQJUB23EDXRZJ+FJAGq42tOiBqg+7oRmPvP+LvVee0sAQvJEhTnLUQMNFtnIVmC4ryFiIFm6ywkS1CctxAx0GydhWQJivMWIgaarbOQLEFx3kLEQLN1FpIlKM5biBhots5CsgTFeQsRA83WWUiWoDhvIWKg2br/ASJpaoOHfouNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteWhite);
export default __webpack_public_path__ + "static/media/QuoteWhite.fd21de0ac9e4edebf7d1e1fcf5a4e177.svg";
export { ForwardRef as ReactComponent };